import { useEffect } from "react";

export default function useScrollReveal(deps = []) {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal:not(.reveal-visible)");

    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("reveal-visible"));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -30px 0px" });

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, deps);
}
